import axios from "axios";
import config from "../config";

const addToKlaviyo = async (list, email) => {
  try {
    const payload = { list, email };
    const response = await axios.post(`${config.apiConfig.API_ENDPOINT_URL}/newsletter/addToKlaviyoNewsletter`, payload);

    // Server response handling
    if (response.data.success) {
      console.log("User added to Klaviyo successfully");
      return response.data;
    } else {
      throw new Error(response.data.error || "Failed to add user to Klaviyo.");
    }
  } catch (error) {
    console.error("Error in addToKlaviyo:", error.message);
    throw error;
  }
};

export default addToKlaviyo;
